import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input, HostListener } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { consumeEvent, UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiUserProfileComponent {

    @Input() hasWelcomeLabel = false;
    @Input() welcomeLabel = 'Welcome';
    @Input() impersonateLabel = 'impersonating';
    @Input() avatarUrl: string;
    @Input()
    get euiUserProfileSizeS() { return this._euiUserProfileSizeS; }
    set euiUserProfileSizeS(value) { this._euiUserProfileSizeS = coerceBooleanProperty(value); }
    _euiUserProfileSizeS = false;

    isOnline = true;

    constructor(
        public asServie: UxAppShellService,
    ) {
    }

    @HostBinding('class')
    public get cssClasses(): any {
        return this.getCssClasses();
    }

    getCssClasses() {
        return [
            `eui-user-profile`,
            this._euiUserProfileSizeS ? 'eui-user-profile--size-s' : '',
        ].join(' ').trim();
    }
}
